/**
 * 货币格式化
 * currencyType 货币符号
 */
let thousands = num => {
  // 金额添加逗号
  if (!num && num !== 0) return "";
  let str = num.toString();
  let reg =
    str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg, "$1,");
};
let TenThousand = num => {
  //金额取万
  if (!num) {
    return 0;
  }
  if (num < 10000) {
    return num + "";
  } else {
    num = (num - (num % 1000)) / 10000;
    return num + "w";
  }
};
/**
 * 数字加两位浮点
 * currencyType 货币符号
 */
let toDecimal2 = x => {
  if (!x && x !== 0) return "";
  // 强制保留两位小数
  let f = parseFloat(x);
  //isNaN() 函数用于检查其参数是否是非数字值,如果 x 是特殊的非数字值 NaN（或者能被转换为这样的值），返回的值就是 true。如果 x 是其他值,则返回 false。
  if (isNaN(f)) {
    return false;
  }
  let t = Math.round(x * 100) / 100; //round() 方法可把一个数字舍入为最接近的整数
  let s = t.toString();
  let rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + 2) {
    s += "0";
  }
  return s;
};
/**
 * 数字前面加0
 * padding 货币符号
 */
let padding = (num, length) => {
  return (Array(length).join("0") + num).slice(-length);
};
export { thousands, toDecimal2, TenThousand, padding };
